import React, {Fragment} from "react";
import NsDataTable from "../../../components/tabelle/NsDataTable";
import PermessiKpiView from "./PermessiKpiView";

export default function PermessiKpiController({
                                        permessiKpi,
                                        translate,
                                        setPermessiKpi,
                                    }) {

    function onChangeAll(event, attr) {
        let permessiKpiNew = JSON.parse(JSON.stringify(permessiKpi));
        for (let i = 0; i < permessiKpiNew.length; i++) {
            if (event.target.checked) {
                permessiKpiNew[i][attr] = 1;
            } else {
                permessiKpiNew[i][attr] = 0;
            }
        }
        setPermessiKpi(permessiKpiNew);
    }

    function onChangeSingle(event, row, attr) {
        let permessiKpiNew = JSON.parse(JSON.stringify(permessiKpi));
        for (let i = 0; i < permessiKpiNew.length; i++) {
            if (permessiKpiNew[i].id_kpi === row.id_kpi
                && permessiKpiNew[i].id_tipo_imp_dati === row.id_tipo_imp_dati) {
                if (event.target.checked) {
                    permessiKpiNew[i][attr] = 1;
                } else {
                    permessiKpiNew[i][attr] = 0;
                }
            }
        }
        setPermessiKpi(permessiKpiNew);
    }

    function onChangeAllLettura(event) {
        onChangeAll(event, 'lettura');
    }

    function onChangeLettura(event, row) {
        onChangeSingle(event, row, 'lettura');
    }

    function onChangeAllScrittura(event) {
        onChangeAll(event, 'scrittura');
    }

    function onChangeScrittura(event, row) {
        onChangeSingle(event, row, 'scrittura');
    }

    function onChangeAllApprovazione(event) {
        onChangeAll(event, 'approvazione');
    }

    function onChangeApprovazione(event, row) {
        onChangeSingle(event, row, 'approvazione');
    }

    function onChangeAllRevisione(event) {
        onChangeAll(event, 'revisione');
    }

    function onChangeRevisione(event, row) {
        onChangeSingle(event, row, 'revisione');
    }

    function onChangeAllConfigurazione(event) {
        onChangeAll(event, 'configurazione');
    }

    function onChangeConfigurazione(event, row) {
        onChangeSingle(event, row, 'configurazione');
    }

    return (
        <PermessiKpiView
            translate={translate}
            permessiKpi={permessiKpi}
            onChangeAllLettura={onChangeAllLettura}
            onChangeLettura={onChangeLettura}
            onChangeAllScrittura={onChangeAllScrittura}
            onChangeScrittura={onChangeScrittura}
            onChangeAllApprovazione={onChangeAllApprovazione}
            onChangeApprovazione={onChangeApprovazione}
            onChangeAllRevisione={onChangeAllRevisione}
            onChangeRevisione={onChangeRevisione}
            onChangeAllConfigurazione={onChangeAllConfigurazione}
            onChangeConfigurazione={onChangeConfigurazione}
        />
    );
}